import React, {forwardRef} from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import "./Button.scss";

const Button = forwardRef(({ to, variant = "primary", className, children, ...props }, ref) => {

    const btnClass = classNames("button", variant, className);

    if (to) {
        return (
            <Link ref={ref} to={to} className={btnClass} {...props}>
                {children}
            </Link>
        );
    }

    return (
        <button
            ref={ref}
            className={btnClass}
            {...props}
        >
            {children}
        </button>
    );
});

export default Button;